// frontend/src/actions/analyticsActions.js
import api from '../utils/api';
import {
  PROFIT_ANALYSIS_REQUEST,
  PROFIT_ANALYSIS_SUCCESS,
  PROFIT_ANALYSIS_FAIL,
  SALES_TRENDS_REQUEST,
  SALES_TRENDS_SUCCESS,
  SALES_TRENDS_FAIL,
  SEASONAL_ANALYSIS_REQUEST,
  SEASONAL_ANALYSIS_SUCCESS,
  SEASONAL_ANALYSIS_FAIL,
  PRODUCT_PERFORMANCE_REQUEST,
  PRODUCT_PERFORMANCE_SUCCESS,
  PRODUCT_PERFORMANCE_FAIL,
  INVENTORY_HEALTH_REQUEST,
  INVENTORY_HEALTH_SUCCESS,
  INVENTORY_HEALTH_FAIL,
  ANALYTICS_DASHBOARD_REQUEST,
  ANALYTICS_DASHBOARD_SUCCESS,
  ANALYTICS_DASHBOARD_FAIL
} from '../constants/analyticsConstants';

// 获取利润分析
export const fetchProfitAnalysis = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: PROFIT_ANALYSIS_REQUEST });
    
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const { data } = await api.get(`/analytics/profit-analysis?${params}`);
    
    dispatch({
      type: PROFIT_ANALYSIS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: PROFIT_ANALYSIS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取销售趋势
export const fetchSalesTrends = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: SALES_TRENDS_REQUEST });
    
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const { data } = await api.get(`/analytics/sales-trends?${params}`);
    
    dispatch({
      type: SALES_TRENDS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: SALES_TRENDS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取季节性分析
export const fetchSeasonalAnalysis = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: SEASONAL_ANALYSIS_REQUEST });
    
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const { data } = await api.get(`/analytics/seasonal-analysis?${params}`);
    
    dispatch({
      type: SEASONAL_ANALYSIS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: SEASONAL_ANALYSIS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取产品性能分析
export const fetchProductPerformance = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_PERFORMANCE_REQUEST });
    
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const { data } = await api.get(`/analytics/product-performance?${params}`);
    
    dispatch({
      type: PRODUCT_PERFORMANCE_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_PERFORMANCE_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取库存健康度分析
export const fetchInventoryHealth = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: INVENTORY_HEALTH_REQUEST });
    
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const { data } = await api.get(`/analytics/inventory-health?${params}`);
    
    dispatch({
      type: INVENTORY_HEALTH_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: INVENTORY_HEALTH_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取仪表板数据
export const fetchAnalyticsDashboard = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: ANALYTICS_DASHBOARD_REQUEST });
    
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const { data } = await api.get(`/analytics/dashboard?${params}`);
    
    dispatch({
      type: ANALYTICS_DASHBOARD_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: ANALYTICS_DASHBOARD_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};